<template>
    <div>

    </div>

</template>

<script>
// lib
import moment from 'moment';
import payComp from '../shixunApp/payComp';

// style
import '@/components/coupon/coupon.scss';

// data
import bizTypeEnum          from '@/data/bizTypeEnum';
import couponBizTypeEnum    from '@/components/coupon/couponBizTypeEnum';

// util
// import consoleHelper     from "@/util/consoleHelper";
import appHelper            from "@/util/appHelper";

const config = {
    apiConfig : {
        submitOrder : {
            url : "portal/v4/order/pay",
            method : 'post',
            idName : 'bizId',
            params : {
                orderBizType : 'UNDERLINE_COURSE'
            }
        },
        getPayStatus : {
            url : "portal/order/pay/update_order_status",
            method : 'post'
        },
        couponList : {
            url : "portal/v2/coupon/getUseCouponsList",
            params : {
                bizType : bizTypeEnum.VOD.code,
                orderBizType : couponBizTypeEnum.VOD.code
            }
        }
    }
};
export default {
    name: "underlineCoursePayComp",
    extends : payComp,
    data() {
        return {
            apiConfig : config.apiConfig
        }
    }
}
</script>
<style lang="scss" scoped>

</style>
